// extracted by mini-css-extract-plugin
export var popup_shipping_info_desktop = "styles-module--popup_shipping_info_desktop--e88d0";
export var popup_shipping_info_mobile = "styles-module--popup_shipping_info_mobile--aa1af";
export var popup_shipping_info_mobile_content = "styles-module--popup_shipping_info_mobile_content--58233";
export var popup_shipping_info_mobile_title = "styles-module--popup_shipping_info_mobile_title--561ae";